import { render, staticRenderFns } from "./instfooter.vue?vue&type=template&id=a64fbe18&scoped=true"
import script from "./instfooter.vue?vue&type=script&lang=js"
export * from "./instfooter.vue?vue&type=script&lang=js"
import style0 from "./instfooter.vue?vue&type=style&index=0&id=a64fbe18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a64fbe18",
  null
  
)

export default component.exports